module.exports = __webpack_public_path__ + "img/1.cf2cb45f.png";